import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

type Props = HTMLAttributes<HTMLElement>;

function Typography(props: Props) {
  return <span {...props} className={cn('text-body text-gray-400', props.className)} />;
}

Typography.Heading = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <h1 ref={ref} {...props} className={cn('text-heading text-white', props.className)} />
));

Typography.Subheading = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <h2 ref={ref} {...props} className={cn('text-subheading text-white', props.className)} />
));

Typography.Title = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <h3 ref={ref} {...props} className={cn('text-title text-white', props.className)} />
));

Typography.Subtitle = forwardRef<HTMLHeadingElement, Props>((props, ref) => (
  <h4 ref={ref} {...props} className={cn('text-subtitle text-white', props.className)} />
));

Typography.Body = forwardRef<HTMLParagraphElement, Props>((props, ref) => (
  <p ref={ref} {...props} className={cn('text-body text-gray-400', props.className)} />
));

Typography.Caption = forwardRef<HTMLParagraphElement, Props>((props, ref) => (
  <p ref={ref} {...props} className={cn('text-caption text-gray-400', props.className)} />
));

Typography.Label = forwardRef<HTMLLabelElement, HTMLAttributes<HTMLLabelElement> & { htmlFor?: string }>((props, ref) => (
  <label ref={ref} {...props} className={cn('text-label text-white', props.className)} />
));

Typography.Heading.displayName = 'Typography.Heading';
Typography.Subheading.displayName = 'Typography.Subheading';
Typography.Title.displayName = 'Typography.Title';
Typography.Subtitle.displayName = 'Typography.Subtitle';
Typography.Body.displayName = 'Typography.Body';
Typography.Caption.displayName = 'Typography.Caption';
Typography.Label.displayName = 'Typography.Label';

export default Typography;
